module.exports = __webpack_public_path__ + "static/media/hmj.d423b831.svg";